import React from "react";
import { FaStar } from "react-icons/fa6";
import { FiMinus, FiPlus } from "react-icons/fi";
import { useNavigate, useOutletContext } from "react-router";

const ProductInfo = ({
  product,
  amount,
  updateCount,
  options,
  setOptions,
  handleCart,
  handleCheckout,
}) => {
  const { theme, url } = useOutletContext();
  const navigate = useNavigate();

  const details = [
    {
      title: "판매가",
      content: product?.price ? `${formatNumber(product.price)}원` : "가격 문의",
    },
    {
      title: "수량",
      content: (
        <div className="control">
          <button className="quantity-btn" onClick={() => updateCount(false)}>
            <FiMinus />
          </button>
          <span className="quantity-value">{amount}</span>
          <button className="quantity-btn" onClick={() => updateCount(true)}>
            <FiPlus />
          </button>
        </div>
      ),
    },
    {
      title: "총 합계",
      className: "total",
      content: product?.price ? (
        <strong>{formatNumber(amount * product.price)}원</strong>
      ) : (
        "가격 문의"
      ),
    },
  ];

  const totalPrice = () => {
    const extra = (options || [])
      .map(
        (group) =>
          group.options.find((opt) => String(opt.id) === String(group.selection))?.addPrice || 0,
      )
      .reduce((acc, price) => acc + price, 0);

    const total = amount * (product.price + extra);
    return formatNumber(total);
  };

  return (
    <div className="info">
      <div className="productInfo">
        <span className="brand">{product?.brand || ""}</span>
        <h2 className="name">{product?.name || "상품명 없음"}</h2>
        <div className="rating">
          <FaStar />
          <span>4.8</span>
          <button>리뷰 0</button>
        </div>
        <div className="price">
          <strong>{product?.price ? `${formatNumber(product.price)}원` : "가격 문의"}</strong>
          <span> {product?.price ? `${formatNumber(product.price)}원` : "가격 문의"}</span>
        </div>
      </div>
      <div className="label price">
        <div className="tit">판매가</div>
        <div className="cont">
          <strong>{product?.price ? `${formatNumber(product.price)}원` : "가격 문의"}</strong>
        </div>
      </div>
      <div className="productCount">
        <div className="tit">{product?.name || "상품명 없음"}</div>
        <div className="cont">
          <div className="selectCount">
            <button onClick={() => updateCount(false)}>
              <FiMinus />
            </button>
            <span>{amount}</span>
            <button onClick={() => updateCount(true)}>
              <FiPlus />
            </button>
          </div>
          <div className="price">
            {product?.price ? (
              <>
                <strong>{formatNumber(amount * product.price)}원</strong>
              </>
            ) : (
              <span>가격 문의</span>
            )}
          </div>
        </div>
      </div>
      {Array.isArray(options) && options.length > 0 && (
        <>
          <div className="label">
            <div className="tit">옵션</div>
          </div>
          <ul className="options">
            {options.map((item) => (
              <li>
                <select
                  value={item.selection ?? "not"}
                  onChange={(e) => {
                    const selectedValue = e.target.value;

                    setOptions((prev) =>
                      prev.map((group) =>
                        group.id === item.id ? { ...group, selection: selectedValue } : group,
                      ),
                    );
                  }}>
                  <option value={"not"}>
                    {item.name}
                    {item.isRequired ? " (필수선택)" : ""}
                  </option>
                  {item.options.map((opt) => (
                    <option value={opt.id}>{opt.value}</option>
                  ))}
                </select>
              </li>
            ))}
          </ul>
        </>
      )}
      <div className="label">
        <div className="tit">총 합계</div>
        <div className="cont price">
          {product?.price ? (
            <>
              {/* <span>{formatNumber(amount * product.price)}원</span> */}
              <strong>{totalPrice()}원</strong>
            </>
          ) : (
            <span>가격 문의</span>
          )}
        </div>
      </div>
      <div className="actions">
        {theme !== 4 ? (
          <>
            <button onClick={handleCart}>장바구니</button>
            <button onClick={handleCheckout}>바로구매</button>
          </>
        ) : (
          <button
            onClick={() =>
              navigate(`/shop/${url}/shoppingNotice?page=0`, { state: { tabIndex: 1 } })
            }>
            문의하기
          </button>
        )}
      </div>
    </div>
  );
};

export default ProductInfo;
